export const urls = {
	projectsForIds: '/rest/jpo/1.0/projects/list',
} as const;
